/*
 * @Author: ZWS
 * @Date: 2021-06-22 18:08:24
 * @LastEditTime: 2023-03-27 10:25:40
 * @Description: 查看图层逻辑文件
 */
import appConfig from 'appConfig';
import { getArcgisService } from "@/api/service-publish";
export default {
  name: "ViewLayer",
  components: {},
  data() {
    Array.prototype.remove = function (obj) {
      for (var i = 0; i < this.length; i++) {
        var temp = this[i];
        if (!isNaN(obj)) {
          temp = i;
        }
        if (temp == obj) {
          for (var j = i; j < this.length; j++) {
            this[j] = this[j + 1];
          }
          this.length = this.length - 1;
        }
      }
    };
    return {
      resultShow: false,
      map: "",
      mapConfig: {},
      drawGrid: {
        polygonJson: [],
      },
      analysisData: [],
      zindex: 500,
      currentArr: [],
      currentResult: {
        title: "",
        inputArea: "",
        count: 0,
      },
      zxQueryLayer: "",
      pointStr: [],
      curLayer: {},
      dataGeometry: "",
      gridDrawLayer: null,
      gridDraws: null,
      columns1: [],
      aData: [],
      loadtree: "数据加载中...",
      pageinfo: {
        count: 0, //总条数
        pagesize: 10, //每页显示的条数
        current: 1, //当前页码
      },
      loading: false,
      Featurecollection: [],
      projection: "",
      baseMapImgLayer: null,
      exportloading: false,
      toolsData: [
        { id: "2", type: "zoomIn", name: "放大" },
        { id: "3", type: "zoomOut", name: "缩小" },
        { id: "6", type: "print", name: "截图" },
      ],
      zxDrawm: {},
      isActive: "",
      isHover: false,
      fieldConfig: [],
      field: [],
      pointMap: null,
      filtercondition: {
        fild: "", //字段
        operator: "", //运算符
        value: "", //属性值
        Where: "", //条件
        type: "", //字段类型
        layerfilterid: "", //当前图层id
      },
      rightTreeData: [], //列表树的数据
      contextData: {},
      currentLayerInfo: {
        wfs: {},
      },
      zindex: 200,
      hidebottom: false, //false表示不收缩，true表示收缩
    };
  },
  props: {
    mapPreviewObj: Object,
    checkObj: Object,
    isShowLayer: {
      type: Boolean,
      default: true,
    },
    isFlagMylayer: String,
  },
  watch: {},
  computed: {
    changeStyle() {
      return {
        color: this.isActive
          ? this.changeColor.color
          : this.isHover
          ? this.changeColor.color
          : "#f8f8f2",
        backgroundColor: this.isActive
          ? this.changeColor.bgColor
          : this.isHover
          ? this.changeColor.bgColor
          : "#545453",
      };
    },
  },
  created() {
    this.mapConfig = appConfig.map; //地图的配置
    // 若图层存在 地图服务存在
    if (this.map && this.pointMap) {
      this.map.removeLayer(this.pointMap);
    }
    // this.getServiceR();
  },
  mounted() {
    this.fieldConfig = this.mapConfig.configfield
      ? this.mapConfig.configfield
      : []; //获取别名字段
    this.init();
    if (this.isFlagMylayer && this.isFlagMylayer == "Mylayer") {
      this.checkObj.serviceName = this.checkObj.title; //表头名称赋值
      this.addshpLayer(this.checkObj);
    } else {
    }
  },
  methods: {
    /**
     * @description 初始化地图信息
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    init() {
      var extent = [-180, -90, 180, 90];
      this.projection = new ol.proj.Projection({
        code: this.mapConfig.proj,
        units: ol.proj.Units.METERS,
        extent: extent,
      });
      this.map = new ol.Map({
        logo: false,
        target: "themeMap",
        layers: [],
        controls: ol.control.defaults({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
        view: new ol.View({
          center: [
            parseFloat(this.mapConfig.center.lng),
            parseFloat(this.mapConfig.center.lat),
          ],
          zoom: this.mapConfig.zoom,
          projection: this.projection,
        }),
      });
      /**
       * @description 增加绘制图层
       * @param
       * @author qqjuanqq
       * @date 2020-06-25
       */
      this.map.zxDrawLayer = new ol.layer.Vector({
        id: "__draw",
        zIndex: 1002,
        source: new ol.source.Vector(),
        style: new ol.style.Style({
          //图层样式
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.2)", //填充颜色
          }),
          stroke: new ol.style.Stroke({
            color: "#ffcc33", //边框颜色
            width: 2, // 边框宽度
          }),
        }),
      });
      this.map.addLayer(this.map.zxDrawLayer);
      /**
       * @description 加载查询图层
       * @param
       * @author qqjuanqq
       * @date 2020-06-25
       */
      this.zxQueryLayer = new ol.layer.Vector({
        id: "__query",
        source: new ol.source.Vector(),
        zIndex: 1001,
        style: new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: "rgba(0, 0, 255, 1)",
            width: 2,
          }),
          fill: new ol.style.Fill({
            color: "rgba(0, 0, 255, 0.3)", //填充颜色
          }),
        }),
      });
      this.map.addLayer(this.zxQueryLayer);
      //关闭这个地图上的弹框
      this.map.zxClosePops = function () {
        var pops = this.zxPops;
        if (pops && pops.length > 0) {
          for (var i = 0; i < pops.length; i++) {
            pops[i].close();
          }
        }
      };
    },
    // 配置的地图服务图层；
    getArcgisBaseLayer(item, zindex, istrue) {
      var layer = new ol.layer.Image({
        // id: item.nodeKey || item.nodeKey == 0 ? '_layertree_' + item.id : item.id,
        id: item.id,
        visible: true,
        zIndex: zindex,
        source: new ol.source.ImageArcGISRest({
          url: item.url,
          params: {
            layers: item.layerId ? "show:" + item.layerId : "",
            TRANSPARENT: false,
          },
          crossOrigin: "anonymous", //防止地图打印出现问题
        }),
      });
      return layer;
    },
    bottomhideClick() {
      // 收缩
      if (this.hidebottom) {
        this.hidebottom = false; //展开
      } else {
        this.hidebottom = true; //收起
      }
    },
    /**
     * @description 渲染shp文件格式
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    addshpLayer(record) {
      var data = record.geometry ? JSON.parse(record.geometry) : "";
      var prefix = "_layertree_";
      var index = 800;
      // 我的图层服务 dwg 和shp文件不查看详情 qqjuanqq  2021-07-09
      if (record.type == "dwg" || record.type == "shp") {
      } else {
        // 查看详情  只有 矢量数据  和  矢量+切片才可以查询
        if (
          record.type.indexOf("VectorgeoServeRest") >= 0 ||
          record.type.indexOf("ServerTilAndVec") >= 0 || 
          record.type.indexOf("ImageGeoServerVectorSlicing") >= 0
        ) {
          this.spaQ_geoServer(record, 0);
        }
      }
      record.features = record.geometry;
      var layer = this.createLayer(record, prefix, index);
      this.map.addLayer(layer);
      this.handleSetZoom(record);
      if (record.features) {
        var data = record.features ? JSON.parse(record.features) : {};
        if (data && data.type) {
          var geojson_format = new ol.format.GeoJSON();
          var features = geojson_format.readFeatures(data);
        } else {
          // dwg保存的数据
          var geojsonArr = {
            type: "FeatureCollection",
            features: [],
          };
          if (data.annotation) {
            geojsonArr.features = data.annotation;
          }
          if (data.point) {
            geojsonArr.features = geojsonArr.features.concat(data.point);
          }
          if (data.polygon) {
            geojsonArr.features = geojsonArr.features.concat(data.polygon);
          }
          if (data.polyline) {
            geojsonArr.features = geojsonArr.features.concat(data.polyline);
          }
          var geojson_format = new ol.format.GeoJSON();
          var features = geojson_format.readFeatures(geojsonArr);
        }
        //wms查询结果
        var source = layer.getSource();
        source.clear();
        source.addFeatures(features);
      }
    },
    // 右键缩放到地图
    async handleSetZoom(record) {
      var extentList = [];
      var _this = this;
      let res = await this.publicMethod.getlayerXML(record.url);
      if (res) {
        $(res)
          .find("Layer")
          .find("Layer")
          .each(function () {
            var item = $(this);
            if (item.find("Name").text() == record.layername.split(":")[1]) {
              extentList.push(
                Number(item.find("LatLonBoundingBox").attr("minx")),
                Number(item.find("LatLonBoundingBox").attr("miny")),
                Number(item.find("LatLonBoundingBox").attr("maxx")),
                Number(item.find("LatLonBoundingBox").attr("maxy"))
              );
              _this.map.getView().fit(extentList);
            }
          });
      }
    },
    /**
     * @description 创建图层服务，处理图层服务的数据
     * @param
     * @author qqjuanqq
     * @date 2020-07-05
     */
    createLayer(config, prefix, zindex) {
      var layer;
      var appConfig = this.mapConfig; //全局地图的配置
      if (
        config.type == "layer.VectorgeoServeRest" ||
        config.type == "layer.ImageGeoServe"
      ) {
        layer = new ol.layer.Tile({
          id: config.id,
          zIndex: zindex,
          source: new ol.source.TileWMS({
            url: config.url,
            crossOrigin: "Anonymous",
            params: {
              LAYERS: config.layername,
              FORMAT: "image/png",
              VERSION: "1.1.0",
            },
            serverType: "geoserver",
          }),
        });
        return layer;
      } else if (
        config.type == "layer.ImageGeoServerTilAndVec" ||
        config.type == "layer.VectorgeoServeCut" ||
        config.type == "layer.ImageGeoServeCut"
      ) {
        //切片的类型
        layer = this.publicMethod.getGeoServerWMTS(
          ol,
          this.projection,
          [
            appConfig.extent.XMin,
            appConfig.extent.YMin,
            appConfig.extent.XMax,
            appConfig.extent.YMax,
          ],
          config,
          appConfig.origin,
          appConfig,
          zindex
        );
      } else if ( (config.type == "polygon" && config.pname == "我的图层") || config.type == "shp" || config.type == "dwg" ) {
        var layerStyle = new ol.style.Style({
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.5)", //填充颜色
          }),
          stroke: new ol.style.Stroke({
            color: "#008000", //边框颜色
            width: 2, // 边框宽度
          }),
          image: new ol.style.Circle({
            radius: 1,
            fill: new ol.style.Fill({
              color: "#008000",
            }),
          }),
          text: new ol.style.Text({
            textBaseline: "middle",
            rotateWithView: true,
            font: "10px Microsoft YaHei",
          }),
        });
        layer = this.publicMethod.createPolygonLayer(
          ol,
          config,
          zindex,
          prefix + config.id,
          layerStyle
        );
        if(JSON.parse(config.features) && JSON.parse(config.features).features.length>0 && JSON.parse(config.features).features[0].geometry.coordinates.length>0){
          this.map.getView().animate({
            center: JSON.parse(config.features).features[0].geometry.coordinates[0][0],
            duration: 1000,
            zoom: this.map.getView().getZoom(),
            easing: ol.easing.Linear,
          });
        }
        // this.map.getView().fit(new ol.source.Vector().getExtent());
      } else if (config.type == 'layer.ImageGeoServerVectorSlicing') {
        //矢量切片的数据
        layer = this.publicMethod.createGeoServerWMTSXYZ(
          ol,
          config,
          this.mapConfig,
          this.projection,
          zindex
        );
      }
      return layer;
    },
    /**
     * 加载ArcGis切片服务
     * @param {*} arg 地图参数
     * @author qqjuanqq
     * @date 2021-07-05
     */
    loadTileArcGIS(arg) {
      var layer = new arg.ol.layer.Tile({
        id: arg.id,
        source: new arg.ol.source.TileArcGISRest({
          url: arg.url,
        }),
      });
      return layer;
    },
    /**
     * @description 右键点击事件
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    handleContextMenu(data) {
      this.contextData = data;
    },
    /**
     * @description 图层目录列表的数据
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    getServiceR() {
      // console.log(this.checkObj);
      var param = {
        serviceName: this.checkObj.serviceName, //服务名称
        serviceType: this.checkObj.type, //服务类型
        folder: this.checkObj.folderName, //服务位置
      };

      this.rightTreeData = [];
      getArcgisService(param)
        .then((res) => {
          if (res.success) {
            var arr = res.result.layers;
            // 列表树的tree事件
            arr.length > 0 &&
              arr.forEach((item, index) => {
                item.title = item.name;
                item.contextmenu = true;
                item.expand = true;
                if (item.children && item.children) {
                  this.setName(item.children);
                }
              });
            this.rightTreeData = arr;
          } else {
          }
        })
        .catch((err) => {});
    },
    /**
     * @description 列表树的render事件
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          class: ["ivu-tree-title"],
          on: {
            click: (e) => {
              let selected = this.$refs.treess.$el.querySelectorAll(
                ".ivu-tree-title-selected"
              );
              for (let i = 0; i < selected.length; i++) {
                selected[i].className = "ivu-tree-title";
              }
              e.path[0].className = "ivu-tree-title  ivu-tree-title-selected"; //当前点击的元素
              this.selectRightTree(node);
            },
          },
        },
        data.title
      );
    },
    /**
     * @description 选择tree的事件
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    selectRightTree(code) {
      this.selectCode = code.node;
      if (this.checkObj.addType.indexOf("arcgis") != -1) {
        // 处理数据
        this.checkObj.bufferUrl = `${this.checkObj.restUrl}Utilities/Geometry/GeometryServer/buffer`; //处理地址数据
        this.checkObj.url = `${this.checkObj.restUrl}${this.checkObj.serviceName}/${this.checkObj.type}`; //处理url地址
        this.checkObj.urlL = `${this.checkObj.restUrl}${this.checkObj.serviceName}/FeatureServer/${this.selectCode.id}`; //处理地址数据
      } else {
        // this.spatialQuery_geoserver(this.contextData); // geoserver的服务
      }
    },
    /**
     * @description 添加地图叠加服务
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    mapshow(preinfo) {
      // 地图截取
      var serviceUrl = preinfo.serviceUrl.split("/export");
      //冲map页面获取map的属性值
      var lon = (parseFloat(preinfo.west) + parseFloat(preinfo.east)) / 2;
      var lat = (parseFloat(preinfo.south) + parseFloat(preinfo.north)) / 2;
      var projection1 = new ol.proj.Projection({
        code: "EPSG:" + preinfo.servicePrj,
        units: "m",
        axisOrientation: "neu",
        global: false,
      });
      // 添加叠加图层服务；
      this.pointMap = new ol.layer.Image({
        visible: true,
        SRS: projection1,
        source: new ol.source.ImageArcGISRest({
          url: serviceUrl[0],
          crossOrigin: "anonymous", //防止地图打印出现问题
        }),
      });
      this.map.addLayer(this.pointMap);
    },
    /**
     * @description 通用XYZ加载方式底图
     * @param
     * @author qqjuanqq
     * @date 2020-06-25
     */
    getArcgisXYZTile(item, resolutions, zindex) {
      let url = item.url;
      var ori = this.mapConfig.origin.split(",");
      var origin = [parseFloat(ori[0]), parseFloat(ori[1])];
      var tileGrid = new ol.tilegrid.TileGrid({
        tileSize: 256,
        origin: origin,
        extent: [
          this.mapConfig.extent.XMin,
          this.mapConfig.extent.YMin,
          this.mapConfig.extent.XMax,
          this.mapConfig.extent.YMax,
        ],
        resolutions: resolutions,
      });
      var tileArcGISXYZ = new ol.source.XYZ({
        tileGrid: tileGrid,
        projection: this.projection,
        url: url,
        crossOrigin: "anonymous", //防止地图打印出现问题
      });

      var layer = new ol.layer.Tile({
        id:
          item.nodeKey || item.nodeKey == 0 ? "_layertree_" + item.id : item.id,
        zIndex: zindex,
        source: tileArcGISXYZ,
      });
      return layer;
    },
    getDataShow_analysis(data, total) {
      if (data.length < 1) {
        this.columns1 = [];
        this.aData = [];
        var source = this.zxQueryLayer.getSource();
        source.clear();
        this.pageinfo.count = 0;
        return;
      }
      this.pageinfo.count = total;
      this.Featurecollection = [];
      var FeatureAllTotal = {
        type: "FeatureCollection",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: [],
      };
      var source = this.zxQueryLayer.getSource();
      source.clear();
      let columns = [];
      columns = [
        {
          title: "序号",
          type: "index",
          align: "center",
          width: 100,
          fixed: "left",
        },
      ];
      let dataArr = [];
      for (var d = 0; d < data.length; d++) {
        var type = data[d].geometryType;
        var features = data[d].features;

        var cc = {};
        var attributesObj = features.attributes;
        Object.keys(attributesObj).forEach(function (key) {
          if (d == 0) {
            var col = {
              title: key.toString(),
              key: key.toString(),
              width: 100,
              align: "center",
            };
            columns.push(col);
          }
          cc[key] = attributesObj[key] ? attributesObj[key].toString() : "";
        });
        dataArr.push(cc);
        if (type.indexOf("Polygon")) {
          // 面
          var das = {
            geometry: {
              coordinates: features.geometry.rings,
              type: "Polygon",
            },
            properties: attributesObj,
            type: "Feature",
          };
        } else if (type.indexOf("LineString")) {
          var das = {
            geometry: {
              coordinates: features.geometry.rings,
              type: "LineString",
            },
            properties: attributesObj,
            type: "Feature",
          };
        } else {
          var das = {
            geometry: {
              coordinates: features.geometry.rings,
              type: "point",
            },
            properties: attributesObj,
            type: "Feature",
          };
        }
        FeatureAllTotal.features.push(das);
      }

      // // 获取别名 判断是否有别名
      this.field = [];
      if (this.fieldConfig.length > 0) {
        for (var f = 0; f < this.fieldConfig.length; f++) {
          if (this.curLayer.title == this.fieldConfig[f].title) {
            this.field = this.fieldConfig[f].field;
            break;
          }
        }
      }
      var fieldsList = this.field;
      if (fieldsList.length > 0) {
        //获取设置别名的
        var fieldAlias = [];
        for (let f = 0; f < fieldsList.length; f++) {
          var fol = {
            key: fieldsList[f].key,
            title: fieldsList[f].alias,
            width: 100,
            align: "center",
          };
          fieldAlias.push(fol);
        }
        for (var f in fieldAlias) {
          var item = columns.find((item) => item.key == fieldAlias[f].key);
          if (item) {
            item.title = fieldAlias[f].title;
          }
        }
      }
      this.aData = dataArr;
      this.columns1 = columns;
      var geojson_format = new ol.format.GeoJSON();
      //空间参考转换
      var feat = geojson_format.readFeatures(FeatureAllTotal);
      this.Featurecollection = feat;
      source.addFeatures(feat);
    },
    /**
     * @author
     * @description TileArcGISRest瓦片服务方式
     */
    getTileArcGISRestLayer(item, resolutions) {
      let url = item.url;
      var ori = this.mapConfig.origin.split(",");
      var origin = [parseFloat(ori[0]), parseFloat(ori[1])];
      var tileGrid = new ol.tilegrid.TileGrid({
        tileSize: 256,
        origin: origin,
        extent: [
          this.mapConfig.extent.XMin,
          this.mapConfig.extent.YMin,
          this.mapConfig.extent.XMax,
          this.mapConfig.extent.YMax,
        ],
        resolutions: resolutions,
      });
      var layer = new ol.layer.Tile({
        id: item.id,
        visible: true,
        source: new ol.source.TileArcGISRest({
          tileGrid: tileGrid,
          projection: this.projection,
          url: url,
          params: {
            name: item.id,
          },
          crossOrigin: "anonymous", //防止地图打印出现问题
        }),
      });
      return layer;
    },
    /**
     * @author
     * @description 构造天地图底图
     */
    getArcgisTileTD(item, zindex) {
      let url = item.url;
      var layer = new ol.layer.Tile({
        id: item.id,
        source: new ol.source.XYZ({
          url: url,
          crossOrigin: "anonymous", //防止地图打印出现问题
        }),
      });
      this.zindex++;
      return layer;
    },
    initDrawC(type, datasource) {
      var result = {};
      var source = new ol.source.Vector();
      if (datasource) {
        source = datasource;
      }
      var gridDrawLayer = new ol.layer.Vector({
        id: "query_draw",
        zIndex: 1003,
        source: source,
        style: new ol.style.Style({
          //图层样式
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.5)", //填充颜色
          }),
          stroke: new ol.style.Stroke({
            color: "#008000", //边框颜色
            width: 2, // 边框宽度
          }), //形状
          image: new ol.style.Circle({
            radius: 5,
            fill: new ol.style.Fill({
              color: "#008000",
            }),
          }),
        }),
      });
      var geometryFunction, maxPoints;
      if (type == "Box") {
        type = "Circle";
        // maxPoints = 2;
        geometryFunction = ol.interaction.Draw.createBox();
      }
      var gridDraws = new ol.interaction.Draw({
        type: type,
        source: gridDrawLayer.getSource(),
        //几何信息变更时调用函数
        geometryFunction: geometryFunction,
        //最大点数
        maxPoints: maxPoints,
      });
      result.gridDrawLayer = gridDrawLayer;
      result.gridDraws = gridDraws;
      return result;
    },
    bottomRemoveClick() {
      this.resultShow = false;
      // 翻页清空
      this.pageinfo.count = 0;
      this.pageinfo.pagesize = 10;
      this.pageinfo.current = 1;
      var source1 = this.zxQueryLayer.getSource();
      source1.clear();
    },
    /*
     * date:2021-6-29
     * Author:qqjuanqq
     * descripte:翻页事件
     *
     */
    changepage(page, byOBJECTId) {
      var pages = (page - 1) * 10;
      // 判断是否是压盖分析
      if (this.analysis || this.analysisdl) {
        this.commonAnalysis(pages);
      } else {
        var where1 = JSON.parse(JSON.stringify(this.contextData));
        if (this.filtercondition.Where) {
          where1.where += " And "; //且
          where1.where += this.filtercondition.Where;
        }
        var feas = {
          contextData: this.contextData,
          page: pages,
          param: where1,
          tital: this.pageinfo.count,
        };
        if (byOBJECTId) {
          this.byOBJECTId = byOBJECTId;
        }
        if (this.contextData.type == "layer.VectorgeoServeRest") {
          var startIndex = (page - 1) * 10;
          this.spaQ_geoServer(this.contextData, startIndex);
        }
      }
    },
    /*
     * date:2021-6-29
     * Author:qqjuanqq
     * descripte:当前行选中 -单击事件
     *
     */
    onrowclick(data, index) {
      let that = this;
      var extent = this.Featurecollection[index].getGeometry().getExtent(); //获取一个坐标数组的边界，格式为[minx,miny,maxx,maxy]
      var center = ol.extent.getCenter(extent); //获取边界区域的中心位置
      this.map.getView().setCenter(center); //设置当前地图的显示中心位置
      this.zxQueryLayer.getSource().forEachFeature(function (fea) {
        fea.setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: "rgba(0, 0, 255, 0.8)",
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 1)", //填充颜色
            }),
          })
        );
      });
      var cnv = document.createElement("canvas");
      var ctx = cnv.getContext("2d");
      var img = new Image();
      img.src = require("../../assets/fill.png");
      img.onload = function () {
        var pattern = ctx.createPattern(img, "repeat");
        that.Featurecollection[index].setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: "rgba(255, 0, 0, 1)",
              width: 3,
            }),
            fill: new ol.style.Fill({
              color: pattern,
            }),
          })
        );
      };
    },
    // 当前行选中 -双击事件
    ondbrowclick(data, index) {
      var extent = this.Featurecollection[index].getGeometry().getExtent(); //获取一个坐标数组的边界，格式为[minx,miny,maxx,maxy]
      var center = ol.extent.getCenter(extent); //获取边界区域的中心位置
      this.map.getView().animate({
        center: center,
        zoom: 16,
      });
      // 获取当前层级
      this.zxQueryLayer.getSource().forEachFeature((fea) => {
        fea.setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: "rgba(0, 0, 255, 0.8)",
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)", //填充颜色
            }),
          })
        );
      });
      this.Featurecollection[index].setStyle(
        new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: "rgba(255, 0, 0, 1)",
            width: 3,
          }),
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.1)", //填充颜色
          }),
        })
      );
      // 使用lodash的cloneDeep进行对象深拷贝
      this.PopWinFea(this.Featurecollection[index], "queryshow");
    },
    /**
     * date 2021-6-29
     * 地图弹出框(指定要素)
     * @param {object} [map] -地图组件
     * @param {object} [fea] -查询的要素信息
     */
    PopWinFea(fea, type, coord) {
      let that = this;
      if (coord) {
        var coordinate = coord;
      } else {
        var coordinate = ol.extent.getCenter(fea.getGeometry().getExtent());
      }
      this.mideaModalVisible = false;
      var props = fea.values_;
      this.feaData = props;
      // 判断是否是识别功能
      if (this.map.distinguish) {
        this.currentLayerInfo = this.map.distinLayer;
      }

      var tbHtml = "";
      var titles = "属性信息";
      if (type == "queryshow") {
        tbHtml +=
          "<div class='spInfo ivu-table-wrapper' style='height: 300px;'><div  class='spAllinfo ivu-table ivu-table-default ivu-table-border'>";
        var tb22 =
          "<table  class='table table-hover tablelist currentul' style='width:100%'>";
        var tr = "";
        that.pdfField = "";

        for (var ims in props) {
          if (ims.toUpperCase() == "OBJECTID") {
            that.byOBJECTId = props[ims];
          }
          // 判断是否配置档案管理字段
          if (
            that.currentLayerInfo &&
            that.currentLayerInfo.wfs &&
            that.currentLayerInfo.wfs.pdfField
          ) {
            if (ims == that.currentLayerInfo.wfs.pdfField) {
              that.pdfField = ims;
            }
          }
          if (
            ims != "OBJECTID_1" &&
            ims != "SHAPE_1_Le" &&
            ims != "bbox" &&
            ims != "geometry"
          ) {
            // 先取别名
            if (
              that.currentLayerInfo &&
              that.currentLayerInfo.wfs &&
              that.currentLayerInfo.wfs.fields &&
              that.currentLayerInfo.wfs.fields.length
            ) {
              // var itmname = that.currentLayerInfo.wfs.fields.find(item => item.key == ims);
              // 判断是否有别名，有排序，如果有的话，按照后台排序显示
              for (
                var f = 0;
                f < that.currentLayerInfo.wfs.fields.length;
                f++
              ) {
                if (that.currentLayerInfo.wfs.fields[f].name == ims) {
                  that.currentLayerInfo.wfs.fields[f]["valuename"] = props[ims];
                }
              }
            } else {
              var popvalue = props[ims];
              if (null == popvalue || "null" == popvalue || "" == popvalue) {
                popvalue = "";
                continue;
              }
              // tr += "<tr><td class='text' title=" + ims + ">" + (itmname22 ? itmname22 : ims) + "</td><td class='text' title=" + props[ims] + ">" + props[ims] + "</td></tr>";
              tr +=
                "<tr><td class='text' title=" +
                ims +
                ">" +
                ims +
                "</td><td class='text' title=" +
                popvalue +
                ">" +
                popvalue +
                "</td></tr>";
            }
          }
        }
        if (
          that.currentLayerInfo &&
          that.currentLayerInfo.wfs &&
          that.currentLayerInfo.wfs.fields &&
          that.currentLayerInfo.wfs.fields.length
        ) {
          // 判断是否有别名，有排序，如果有的话，按照后台排序显示

          // var itmname = that.currentLayerInfo.wfs.fields.find(item => item.key == ims);
          for (var c = 0; c < that.currentLayerInfo.wfs.fields.length; c++) {
            var itmname221 = that.currentLayerInfo.wfs.fields[c].alias;
            var popvalue = that.currentLayerInfo.wfs.fields[c]["valuename"];
            tr +=
              "<tr><td class='text' title=" +
              itmname221 +
              ">" +
              itmname221 +
              "</td><td class='text' title=" +
              popvalue +
              ">" +
              popvalue +
              "</td></tr>";
            // }
          }
        }
        tb22 += tr;
      }
      tbHtml += tb22;
      tbHtml += "</table>";
      tbHtml += "</div>";

      var TXTHTML =
        "<div class='bottom_btn' style='   position: absolute;    bottom: 0px;right: 0px;'>";
      // "<Button onclick='proClick()' type='button' class='b1 ivu-btn ivu-btn-primary' style='margin-right:5px'><i class='ivu-icon ivu-icon-ios-videocam' style='font-size:16px;margin-right:5px;'></i>属性查看</Button>" +
      if (that.pdfField && that.isDocument) {
        TXTHTML +=
          "<Button  onclick='pdfClick()' type='button' class='b1 ivu-btn ivu-btn-primary' style='height:25px;'>图档管理</Button>";
        that.getmeideaList(props, that.pdfField);
      }
      tbHtml += TXTHTML;
      tbHtml += "</div>";
      this.map.zxClosePops();
      if (type == "queryshow") {
        this.zxQueryLayer.getSource().forEachFeature(function (fea) {
          fea.setStyle(
            new ol.style.Style({
              stroke: new ol.style.Stroke({
                color: "rgba(0, 0, 255, 0.8)",
                width: 2,
              }),
              fill: new ol.style.Fill({
                color: "rgba(255, 255, 255, 0.2)", //填充颜色
              }),
            })
          );
        });
      }
      this.PopWin(this.map, {
        center: coordinate,
        content: tbHtml,
        title: titles,
      });
    },
    /**
     * date 2021-6-29
     * 地图弹出框
     * @param {object} [map] -地图组件
     * @param {object} [fea] -查询的要素信息
     */
    PopWin(map, options) {
      var _this = this;
      var div = $(`<div class="ol-popup">
        <div class='ol-popup-title'>    
          <span id="title">属性</span>
          <a href="#" class="ol-popup-closer" ><i class="ivu-icon ivu-icon-md-close  ttt" style='color:#ffffff;font-size:16px'></i></a>
        </div>
        <div class="popup-content" style="background: white"></div>
      </div>`);
      $(map.getTargetElement()).append(div);
      // _this.target = div;
      div.find(".ol-popup-closer").click(function () {
        _this.close();
      });
      div.find(".popup-content").append(options.content);
      _this.centers = options.center;
      this.overlay = new ol.Overlay({
        element: div[0],
        autoPan: true,
        positioning: "center-left",
        autoPanAnimation: {
          duration: 250,
        },
      });
      this.viewF = function () {
        _this.overlay.setPosition(_this.center);
        _this.map.addOverlay(_this.overlay);
      };
      this.show = function () {
        _this.overlay.setPosition(_this.centers);
        _this.map.addOverlay(_this.overlay);
      };
      this.close = function () {
        _this.map.removeOverlay(_this.overlay);
        div.remove();
        var pops = _this.map.zxPops;
        if (pops && pops.indexOf(_this) >= 0) {
          pops.splice(pops.indexOf(_this), 1);
        }
      };
      this.map.zxClosePops();
      this.show();
      this.map.zxPops = this.map.zxPops || [];
      this.map.zxPops.push(this);
      //弹出框标题赋值
      $("#title").html(options.title);
    },
    /*
     * date:2021-6-29
     * Author:qqjuanqq
     * descripte:工具栏中工具事件选择
     *
     */
    clickOptTool(item) {
      if (item.name === "全屏") {
        this.fullScreen(item);
      } else if (item.name === "放大") {
        this.zoomOut();
      } else if (item.name === "缩小") {
        this.zoomIn();
      } else if (item.name === "重置") {
        this.map.getView().setZoom(this.mapConfig.zoom);
        var longitude = this.mapConfig.center.lng;
        var latitude = this.mapConfig.center.lat;
        this.map
          .getView()
          .setCenter([parseFloat(longitude), parseFloat(latitude)]);
      } else if (item.name === "测面") {
        this.startMeasure("Polygon");
      } else if (item.name === "测距") {
        this.startMeasure("LineString");
      } else if (item.name === "清除") {
        this.clearMap();
        this.close(); //清除地图弹框
      } else if (item.name == "截图") {
        this.map.once("postcompose", function (event) {
          var canvas = event.context.canvas;
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(canvas.msToBlob(), "map.png");
          } else {
            canvas.toBlob(function (blob) {
              let URL = window.URL || window.webkitURL;
              let objectUrl = URL.createObjectURL(blob);
              var a = document.createElement("a");
              if (typeof a.download === "undefined") {
                window.location = objectUrl;
              } else {
                a.href = objectUrl;
                a.download = "map.png";
                document.body.appendChild(a);
                a.click();
                a.remove();
              }
              // saveAs(blob, 'map.png');
            });
          }
        });
        this.map.renderSync();
      } else if (item.name == "详情") {
        // 2021-6-29添加
        if (this.checkObj.addType.indexOf("arcgis") != -1) {
        } else {
          // this.spatialQuery_geoserver(this.contextData);
        }
      }
    },
    async spaQ_geoServer(datainfo, pageindex) {
      var appConfig = this.mapConfig; //全局地图的配置
      datainfo.TypeName = datainfo.layername;
      datainfo.SrsName = appConfig.proj;
      datainfo.startIndex = pageindex;
      datainfo.maxFeatures = 10;
      this.contextData = datainfo;
      var pjsonResult = await this.publicMethod.geoServerQuery(
        datainfo.url,
        datainfo,
        ol
      );
      this.pagetotal = pjsonResult.resultData.totalFeatures; //总条数复制
      if (this.pagetotal === 0) {
        this.$Message.warning("查询结果为空");
        return;
      }
      if (
        pjsonResult.resultData &&
        pjsonResult.resultData.features &&
        pjsonResult.resultData.features.length > 0
      ) {
        var fea = {
          features: pjsonResult.featureArr,
          contextData: this.contextData,
          total: this.pagetotal,
          spinShow: false,
          dataparam: datainfo, //查询条件
          totalField: this.totalField, //属性字段类型
        };
        this.getDataShow(fea.features, fea.contextData, fea.total); //接口支持分页查询
      } else {
        this.$bus.emit("queryData", null);
        this.$Message.info("暂无数据!");
      }
    },
    // 打开底部的弹框展示数据；
    getDataShow(Features, currentLayer, total) {
      this.resultShow = true;
      let that = this;
      this.pageinfo.count = total;
      this.contextData = currentLayer;
      if (Features.length > 0) {
        let dataArr = [];
        let columns = [];
        columns = [
          {
            title: "序号",
            type: "index",
            width: 70,
            align: "center",
            fixed: "left",
          },
        ];
        this.Featurecollection = [];
        this.Featurecollection = Features;
        for (let i = 0; i < Features.length; i++) {
          var cc = {};
          for (let items in Features[i].values_) {
            if (
              items != "OBJECTID_1" &&
              items != "SHAPE_1_Le" &&
              items != "bbox" &&
              items != "geometry" &&
              items != "layerPDFid"
            ) {
              if (i == 0) {
                var col = {
                  title: items.toString(),
                  key: items.toString(),
                  minWidth: 100,
                  align: "center",
                };
                columns.push(col);
              }
              const hasDot = function (num) {
                if (!isNaN(num)) {
                  return (num + "").indexOf(".") != -1 ? true : false;
                }
              };
              // 判断类型，时间类型转为时间格式
              if (that.totalField && that.totalField.length > 0) {
                for (var f = 0; f < that.totalField.length; f++) {
                  if (
                    items == that.totalField[f].name &&
                    that.totalField[f].type == "esriFieldTypeDate"
                  ) {
                    if (
                      Features[i].values_[items] &&
                      Features[i].values_[items] != "null"
                    ) {
                      Features[i].values_[items] = that.getdatachange(
                        Features[i].values_[items]
                      );
                    } else {
                      Features[i].values_[items] = "";
                    }
                  }
                }
              }
              if (hasDot(Features[i].values_[items])) {
                // 数字
                Features[i].values_[items] = parseFloat(
                  Features[i].values_[items]
                ).toFixed(4); //小数点截取4位
              }
              cc[items] = Features[i].values_[items]
                ? Features[i].values_[items].toString()
                : "";
            }
          }
          dataArr.push(cc);
        }
        var fieldsList = currentLayer.wfs ? currentLayer.wfs.fields : ""; // 这是修改后的 原来的是currentLayer.wfs.fields
        if (fieldsList) {
          //获取设置别名的
          if (fieldsList.constructor != Array) {
            //当只有一个的时候
            var aa = [];
            aa.push(fieldsList);
            fieldsList = aa;
          }
          var fieldAlias = [];
          for (let f = 0; f < fieldsList.length; f++) {
            var fol = {
              key: fieldsList[f].key,
              title: fieldsList[f].alias,
              minWidth: 100,
              align: "center",
            };
            fieldAlias.push(fol);
          }
        }
        if (
          currentLayer.wfs
            ? currentLayer.wfs.displayColms
              ? true
              : false
            : false
        ) {
          //是否有指定显示字段  这是修改后的 原来的是if(currentLayer.wfs.displayColms)
          var displaycolms = currentLayer.wfs.displayColms.split(",");
          columns = [
            {
              title: "序号",
              type: "index",
              width: 70,
              align: "center",
              fixed: "left",
            },
          ];
          for (let c = 0; c < displaycolms.length; c++) {
            if (fieldAlias) {
              var item = fieldAlias.find((item) => item.key == displaycolms[c]);
              if (item) {
                var col = {
                  title: item.title,
                  key: item.key,
                  minWidth: 100,
                  align: "center",
                };
                columns.push(col);
              } else {
                var col = {
                  title: displaycolms[c],
                  key: displaycolms[c],
                  align: "center",
                  minWidth: 100,
                };
                columns.push(col);
              }
            } else {
              var col = {
                title: displaycolms[c],
                key: displaycolms[c],
                align: "center",
              };
              columns.push(col);
            }
          }
        } else {
          //没有的话重合别名
          if (fieldAlias) {
            for (var f in fieldAlias) {
              var item = columns.find((item) => item.key == fieldAlias[f].key);
              if (item) {
                item.title = fieldAlias[f].title;
              }
            }
          }
        }
        this.columns1 = columns; //表头
        this.aData = dataArr;
      } else {
        this.columns1 = [];
        this.aData = [];
      }
      var source = this.zxQueryLayer.getSource();
      source.clear();
      source.addFeatures(Features);
    },
    // 处理表格的数据
    // getDataShow(Features, currentLayer, total) {
    //   this.resultShow = true;
    //   let that = this;
    //   this.pageinfo.count = total;
    //   this.contextData = currentLayer;
    //   if (Features.length > 0) {
    //     let dataArr = [];
    //     let columns = [];
    //     columns = [
    //       {
    //         title: "序号",
    //         type: "index",
    //         width: 70,
    //         align: "center",
    //         fixed: "left"
    //       }
    //     ];
    //     this.Featurecollection = [];
    //     this.Featurecollection = Features;
    //     for (let i = 0; i < Features.length; i++) {
    //       var cc = {};
    //       for (let items in Features[i].values_) {
    //         if (
    //           items != "OBJECTID_1" &&
    //           items != "SHAPE_1_Le" &&
    //           items != "bbox" &&
    //           items != "geometry" &&
    //           items != "layerPDFid"
    //         ) {
    //           if (i == 0) {
    //             var col = {
    //               title: items.toString(),
    //               key: items.toString(),
    //               minWidth: 100,
    //               align: "center"
    //             };
    //             columns.push(col);
    //           }
    //           const hasDot = function(num) {
    //             if (!isNaN(num)) {
    //               return (num + "").indexOf(".") != -1 ? true : false;
    //             }
    //           };
    //           // 判断类型，时间类型转为时间格式
    //           if (that.totalField && that.totalField.length > 0) {
    //             for (var f = 0; f < that.totalField.length; f++) {
    //               if (
    //                 items == that.totalField[f].name &&
    //                 that.totalField[f].type == "esriFieldTypeDate"
    //               ) {
    //                 if (
    //                   Features[i].values_[items] &&
    //                   Features[i].values_[items] != "null"
    //                 ) {
    //                   Features[i].values_[items] = that.getdatachange(
    //                     Features[i].values_[items]
    //                   );
    //                 } else {
    //                   Features[i].values_[items] = "";
    //                 }
    //               }
    //             }
    //           }
    //           if (hasDot(Features[i].values_[items])) {
    //             // 数字
    //             Features[i].values_[items] = parseFloat(
    //               Features[i].values_[items]
    //             ).toFixed(4); //小数点截取4位
    //           }
    //           cc[items] = Features[i].values_[items]
    //             ? Features[i].values_[items].toString()
    //             : "";
    //         }
    //       }
    //       dataArr.push(cc);
    //     }
    //     var fieldsList = currentLayer.wfs.fields;
    //     if (fieldsList) {
    //       //获取设置别名的
    //       if (fieldsList.constructor != Array) {
    //         //当只有一个的时候
    //         var aa = [];
    //         aa.push(fieldsList);
    //         fieldsList = aa;
    //       }
    //       var fieldAlias = [];
    //       for (let f = 0; f < fieldsList.length; f++) {
    //         var fol = {
    //           key: fieldsList[f].key,
    //           title: fieldsList[f].alias,
    //           minWidth: 100,
    //           align: "center"
    //         };
    //         fieldAlias.push(fol);
    //       }
    //     }
    //     if (currentLayer.wfs.displayColms) {
    //       //是否有指定显示字段
    //       var displaycolms = currentLayer.wfs.displayColms.split(",");
    //       columns = [
    //         {
    //           title: "序号",
    //           type: "index",
    //           width: 70,
    //           align: "center",
    //           fixed: "left"
    //         }
    //       ];
    //       for (let c = 0; c < displaycolms.length; c++) {
    //         if (fieldAlias) {
    //           var item = fieldAlias.find(item => item.key == displaycolms[c]);
    //           if (item) {
    //             var col = {
    //               title: item.title,
    //               key: item.key,
    //               minWidth: 100,
    //               align: "center"
    //             };
    //             columns.push(col);
    //           } else {
    //             var col = {
    //               title: displaycolms[c],
    //               key: displaycolms[c],
    //               align: "center",
    //               minWidth: 100
    //             };
    //             columns.push(col);
    //           }
    //         } else {
    //           var col = {
    //             title: displaycolms[c],
    //             key: displaycolms[c],
    //             align: "center"
    //           };
    //           columns.push(col);
    //         }
    //       }
    //     } else {
    //       //没有的话重合别名
    //       if (fieldAlias) {
    //         for (var f in fieldAlias) {
    //           var item = columns.find(item => item.key == fieldAlias[f].key);
    //           if (item) {
    //             item.title = fieldAlias[f].title;
    //           }
    //         }
    //       }
    //     }
    //     // 处理表头的数据  qqjuanqq 2021-07-13
    //     var codeNewArr = []
    //     var codeArr = []
    //     for (let i=0;i<columns.length;i++){
    //       for(let j=0;j<this.totalField.length;j++){
    //         if(columns[i].key == this.totalField[j].name) {
    //           columns[i].title = this.totalField[j].alias
    //           codeNewArr.push(this.totalField[j])
    //           codeArr.push({
    //             alias: columns[i].title,
    //             name: columns[i].key,
    //             type: "esriFieldTypeOID",
    //           })
    //         }
    //       }
    //     }
    //     this.columns1 = columns; //表头
    //     this.aData = dataArr;
    //     this.currentLayerInfo.totalField = codeArr //气泡匹配的所需要的数据
    //     this.currentLayerInfo.wfs.fields = codeNewArr  //匹配的fields 字段
    //   } else {
    //     this.columns1 = [];
    //     this.aData = [];
    //   }
    //   var source = this.zxQueryLayer.getSource();
    //   source.clear();
    //   source.addFeatures(Features);
    // },
    // 处理数据的方法
    getdatachange(data) {
      var timestamp4 = "";
      var date = new Date(data);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      timestamp4 = Y + M + D;
      return timestamp4;
    },
    startMeasure(type) {
      this.map.drawOpt = true;
      var map = this.map;
      let that = this;
      if (this.map.zxDrawm) this.map.removeInteraction(map.zxDrawm);
      if (this.map.zxMeasureTooltip)
        this.map.removeOverlay(this.map.zxMeasureTooltip);
      if (this.map.zxHelpTooltip) this.map.removeOverlay(map.zxHelpTooltip);
      if (this.map.zxMeasureTipStack) {
        for (var i = 0; i < this.map.zxMeasureTipStack.length; i++)
          this.map.removeOverlay(this.map.zxMeasureTipStack[i]);
      }
      this.map.zxDrawLayer.getSource().clear();
      this.map.zxDrawm = new ol.interaction.Draw({
        type: type,
        source: this.map.zxDrawLayer.getSource(),
        style: new ol.style.Style({
          //绘制几何图形的样式
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
          stroke: new ol.style.Stroke({
            color: "rgba(255, 0, 0, 0.5)",
            width: 2,
          }),
          image: new ol.style.Circle({
            radius: 4,
            stroke: new ol.style.Stroke({
              color: "rgba(255, 0, 0, 0.7)",
            }),
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
          }),
        }),
      });
      this.map.addInteraction(this.map.zxDrawm);
      var listener, sketch;
      this.map.zxDrawm.on("drawstart", function (evt) {
        sketch = evt.feature; //绘制的要素
        var tooltipCoord = evt.coordinate; // 绘制的坐标
        //绑定change事件，根据绘制几何类型得到测量长度值或面积值，并将其设置到测量工具提示框中显示
        listener = sketch.getGeometry().on("change", function (evt) {
          var geom = evt.target; //绘制几何要素
          var output;
          if (geom instanceof ol.geom.Polygon) {
            output = formatArea(/** @type {ol.geom.Polygon} */ (geom)); //面积值
            tooltipCoord = geom.getInteriorPoint().getCoordinates(); //坐标
          } else if (geom instanceof ol.geom.LineString) {
            output = formatLength(/** @type {ol.geom.LineString} */ (geom)); //长度值
            tooltipCoord = geom.getLastCoordinate(); //坐标
          }
          that.map.zxMeasureTooltipElement.innerHTML = output; //将测量值设置到测量工具提示框中显示
          that.map.zxMeasureTooltip.setPosition(tooltipCoord); //设置测量工具提示框的显示位置
        });
        createHelpTooltip();
        createMeasureTooltip();
        that.map.on("pointermove", pointerMoveHandler); //地图容器绑定鼠标移动事件，动态显示帮助提示框内容
      });
      //绑定交互绘制工具结束绘制的事件
      this.map.zxDrawm.on(
        "drawend",
        function (evt) {
          // zx.map.zxState = 0;
          that.map.zxMeasureTooltipElement.className = "tooltip tooltip-static"; //设置测量提示框的样式
          that.map.zxMeasureTooltip.setOffset([0, -7]);
          // unset sketch
          sketch = null; //置空当前绘制的要素对象
          // unset tooltip so that a new one can be created
          that.map.zxMeasureTooltipElement = null; //置空测量工具提示框对象
          that.map.zxMeasureTipStack = that.map.zxMeasureTipStack || [];
          that.map.zxMeasureTipStack.push(that.map.zxMeasureTooltip);
          createMeasureTooltip(); //重新创建一个测试工具提示框显示结果
          ol.Observable.unByKey(listener);
        },
        this
      );
      //地图绑定鼠标移出事件，鼠标移出时为帮助提示框设置隐藏样式
      $(that.map.getViewport()).on("mouseout", function () {
        $(that.map.zxHelpTooltipElement).addClass("hidden");
      });
      /**
       *创建一个新的帮助提示框（tooltip）
       */
      function createHelpTooltip() {
        if (that.map.zxHelpTooltipElement) {
          that.map.zxHelpTooltipElement.parentNode.removeChild(
            that.map.zxHelpTooltipElement
          );
        }
        that.map.zxHelpTooltipElement = document.createElement("div");
        that.map.zxHelpTooltipElement.className = "tooltip hidden";
        that.map.zxHelpTooltip = new ol.Overlay({
          element: that.map.zxHelpTooltipElement,
          offset: [15, 0],
          positioning: "center-left",
        });
        that.map.addOverlay(that.map.zxHelpTooltip);
      }
      /**
       *创建一个新的测量工具提示框（tooltip）
       */
      function createMeasureTooltip() {
        if (that.map.zxMeasureTooltipElement) {
          that.map.zxMeasureTooltipElement.parentNode.removeChild(
            that.map.zxMeasureTooltipElement
          );
        }
        that.map.zxMeasureTooltipElement = document.createElement("div");
        that.map.zxMeasureTooltipElement.className = "tooltip tooltip-measure";
        that.map.zxMeasureTooltip = new ol.Overlay({
          element: that.map.zxMeasureTooltipElement,
          offset: [0, -50],
          positioning: "center-left",
        });
        that.map.addOverlay(that.map.zxMeasureTooltip);
      }
      /**
       * 测量长度输出
       * @param {ol.geom.LineString} line
       * @return {string}
       */
      var formatLength = function (line) {
        var length;
        length = Math.round(line.getLength() * 100) / 100; //直接得到线的长度
        var output;
        if (length > 100) {
          output = Math.round((length / 1000) * 100) / 100 + " " + "km"; //换算成KM单位
        } else {
          output = Math.round(length * 100) / 100 + " " + "m"; //m为单位
        }
        return output; //返回线的长度
      };
      /**
       * 测量面积输出
       * @param {ol.geom.Polygon} polygon
       * @return {string}
       */
      var formatArea = function (polygon) {
        var area;
        area = polygon.getArea(); //直接获取多边形的面积
        var output;
        if (area > 10000) {
          output =
            Math.round((area / 1000000) * 100) / 100 + " " + "km<sup>2</sup>"; //换算成KM单位
        } else {
          output = Math.round(area * 100) / 100 + " " + "m<sup>2</sup>"; //m为单位
        }
        return output; //返回多边形的面积
      };
      /**
       *  当用户正在绘制多边形时的提示信息文本
       * @type {string}
       */
      var continuePolygonMsg = "单击继续绘制多边形";
      /**
       * 当用户正在绘制线时的提示信息文本
       * @type {string}
       */
      var continueLineMsg = "单击继续绘制线";
      /**
       * 鼠标移动事件处理函数
       * @param {ol.MapBrowserEvent} evt
       */
      function pointerMoveHandler(evt) {
        if (evt.dragging) {
          return;
        }
        /** @type {string} */
        var helpMsg = "开始绘制"; //当前默认提示信息
        //判断绘制几何类型设置相应的帮助提示信息
        if (sketch) {
          var geom = sketch.getGeometry();
          if (geom instanceof ol.geom.Polygon) {
            helpMsg = continuePolygonMsg; //绘制多边形时提示相应内容
          } else if (geom instanceof ol.geom.LineString) {
            helpMsg = continueLineMsg; //绘制线时提示相应内容
          }
        }
        that.map.zxHelpTooltipElement.innerHTML = helpMsg; //将提示信息设置到对话框中显示
        that.map.zxHelpTooltip.setPosition(evt.coordinate); //设置帮助提示框的位置
        $(that.map.zxHelpTooltipElement).removeClass("hidden"); //移除帮助提示框的隐藏样式进行显示
      }
    },
    /**
     * 清除地图图层服务
     * @param {ol.geom.Polygon} polygon
     * @return {string}
     */
    clearMap() {
      if (this.map.zxDrawm) {
        this.map.removeInteraction(this.map.zxDrawm);
      }
      if (this.map.zxMeasureTooltip)
        this.map.removeOverlay(this.map.zxMeasureTooltip);
      if (this.map.zxHelpTooltip)
        this.map.removeOverlay(this.map.zxHelpTooltip);
      if (this.map.zxMeasureTipStack) {
        for (var i = 0; i < this.map.zxMeasureTipStack.length; i++)
          this.map.removeOverlay(this.map.zxMeasureTipStack[i]);
      }
      if (this.map.zxDrawLayer) {
        this.map.zxDrawLayer.getSource().clear();
      }
    },
    //放大
    zoomOut(item) {
      let view = this.map.getView();
      let zoom = view.getZoom();
      view.setZoom(zoom + 1);
    },
    //缩小
    zoomIn(item) {
      let view = this.map.getView();
      let zoom = view.getZoom();
      view.setZoom(zoom - 1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/viewLayer/viewLayer.js